export default __webpack_public_path__ + "assets/models/draco/Ball.glb";